"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevViewSection = void 0;
const syntax_highlight_json_1 = require("@app/util/syntax-highlight-json");
const react_1 = __importDefault(require("react"));
const shift_context_1 = require("../shift-context");
const DevViewSection = () => {
    const { getValues, formControl, ...context } = (0, shift_context_1.useShift)();
    return (react_1.default.createElement("div", { style: { width: '100%', height: '100%', display: 'flex', flexFlow: 'column' } },
        react_1.default.createElement(syntax_highlight_json_1.SyntaxHighlightJSON, { json: JSON.stringify({
                form: getValues(),
                context,
            }, null, 2) })));
};
exports.DevViewSection = DevViewSection;
